import { Injectable } from '@angular/core';

import {
  ReservationsApiService,
  PriceRequest,
  CalculatedPrice,
  Offer,
  CarserviceEstimate,
  CarServicesApiService,
  ProductExtra,
  AuthenticatedApiService,
  AdminClient,
  AdminClientsApiService,
  AdminReservation,
  AdminReservationApiService,
  ApiService,
} from 'rest-client';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CarEstimateRequest } from '../../models/car-estimate.model';

@Injectable()
export class OfferService {
  constructor(
    private reservationsApiService: ReservationsApiService,
    private carServicesApiService: CarServicesApiService,
    private authenticatedApi: AuthenticatedApiService,
    private adminClientsApiService: AdminClientsApiService,
    private adminReservationApiService: AdminReservationApiService,
    private unauthenticatedApi: ApiService
  ) {}

  extrasAndCarServices(
    priceRequest: PriceRequest
  ): Observable<Partial<CalculatedPrice>> {
    return from(this.reservationsApiService.calculatePrice(priceRequest)).pipe(
      map((calculatedPrice: CalculatedPrice) => ({
        extras: calculatedPrice?.extras,
        car_services: calculatedPrice.car_services,
      }))
    );
  }

  getOffer(
    priceRequest: PriceRequest,
    forceGuest?: boolean
  ): Observable<Offer> {
    return from(
      this.reservationsApiService.calculatePrice(priceRequest, forceGuest)
    ).pipe(map((calculatedPrice: CalculatedPrice) => calculatedPrice.offer));
  }

  getCalculatedPrice(
    priceRequest: PriceRequest,
    forceGuest?: boolean
  ): Observable<CalculatedPrice> {
    return from(
      this.reservationsApiService.calculatePrice(priceRequest, forceGuest)
    ).pipe(map((calculatedPrice: CalculatedPrice) => calculatedPrice));
  }

  getOfferFromReservation(
    reservation_id: string,
    reservation_hash: string,
    priceRequest?: Partial<PriceRequest>
  ): Observable<CalculatedPrice> {
    return from(
      this.reservationsApiService.calculatePriceFromReservation(
        reservation_id,
        reservation_hash,
        priceRequest
      )
    ).pipe(map((calculatedPrice: CalculatedPrice) => calculatedPrice));
  }

  getOfferFromAbsuid(absuid: string): Observable<CalculatedPrice> {
    return from(
      this.reservationsApiService.calculatePriceFromAbsuid(absuid)
    ).pipe(map((calculatedPrice: CalculatedPrice) => calculatedPrice));
  }

  getUrbanOffer(priceRequest: PriceRequest): Observable<Offer> {
    return from(
      this.reservationsApiService.calculatePriceforCarService(priceRequest)
    ).pipe(map((calculatedPrice: CalculatedPrice) => calculatedPrice.offer));
  }

  getExtras(priceRequest: PriceRequest): Observable<ProductExtra[]> {
    return from(this.reservationsApiService.calculatePrice(priceRequest)).pipe(
      map((calculatedPrice: CalculatedPrice) => calculatedPrice?.extras)
    );
  }

  getCarServiceEstimated(
    params: CarEstimateRequest
  ): Observable<CarserviceEstimate> {
    return from(this.carServicesApiService.getCarserviceEstimate(params));
  }

  updateReservationWithCarServices(payload: any): Observable<any> {
    return from(
      this.authenticatedApi
        .post(`/adminmechanicalorder/create_from_booking`, payload)
        .toPromise()
    );
  }

  getAdminClient(idClient: number): Observable<AdminClient> {
    return from(this.adminClientsApiService.getAdminClient(idClient));
  }

  getAdminReservation(idReservation: number): Observable<AdminReservation> {
    return from(
      this.adminReservationApiService.get(idReservation)
    ) as Observable<AdminReservation>;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getWorkshopsBrands(): Observable<any> {
    return from(
      this.unauthenticatedApi.get(`carservice/list_workshop_brands`).toPromise()
    );
  }
}
